import React, { useEffect } from "react";
import Hero from "./home/herosection";
import HomeCategories from "./home/homecategories";
import HomeBestSellers from "./home/productCardsSlider";
import Addbanner2 from "./home/Banner2";
import Addbanner1 from "./home/Addbanner1";
import Newsletter from "./home/newsLetter";
import PersonalCareSlider from "./home/Personalcare";
import HairCare from "./home/HairCare";
import { useDispatch, useSelector } from "react-redux";
import { getBanners } from "../Redux/AllSlices/homeSlider";

const BEST_SELLER_FILTERS = { bestseller: 1 };
const SEASONAL_FILTERS = { seasonal_product: 1 };
const PERSONAL_CARE_FILTERS = { personal_care: 1 };
const HAIR_CARE_FILTERS = { hair_care: 1 };

export default function Home() {
  const dispatch = useDispatch();
  const { banners } = useSelector((state) => state.bannersData);

  useEffect(() => {
    dispatch(getBanners());
  }, [dispatch]);


  return (
    <>
      <Hero banners={banners} />
      <HomeCategories />
      <HomeBestSellers
        heading="Best Sellers"
        productstype={true}
        filters={BEST_SELLER_FILTERS}
      />
      <HomeBestSellers
        heading="Seasonal Products"
        productstype={true}
        filters={SEASONAL_FILTERS}
      />
      <Addbanner1 banners={banners} />
      <Newsletter />
      <Addbanner2 banners={banners} />
      <PersonalCareSlider filters={PERSONAL_CARE_FILTERS} />
      <HairCare filters={HAIR_CARE_FILTERS} />
    </>
  );
}
